var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 21,
    viewBox: "0 0 29 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70075 0.306885C1.60073 0.306885 0.708984 1.19863 0.708984 2.29865V18.2328C0.708984 19.3328 1.60073 20.2245 2.70075 20.2245H8.67605L15.1358 9.24292L20.6266 20.2245H26.6019C27.702 20.2245 28.5937 19.3328 28.5937 18.2328V5.2863C28.5937 4.18628 27.702 3.29453 26.6019 3.29453H20.9132C19.5016 3.29453 18.1954 4.04161 17.4797 5.25833L15.1358 9.24292L11.7688 2.50893C11.0941 1.15937 9.71471 0.306885 8.20586 0.306885H2.70075Z",
    fill: "url(#paint0_linear_3491_26011)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3491_26011",
    x1: 5.6884,
    y1: 23.7101,
    x2: 12.6596,
    y2: -14.1334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01FCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#2297F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161D23",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogo);
export default __webpack_public_path__ + "static/media/mobile-logo.15c02addf3cab8f83ae27cee1e0a171a.svg";
export { ForwardRef as ReactComponent };